import React from "react";
import { Markdown } from "../../generated/core-api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./MarkdownView.module.css";

type MarkdownViewProps = {
  markdown: Markdown;
};

export const MarkdownView: React.FC<MarkdownViewProps> = ({ markdown }) => {
  return (
    <div className={styles.markdownContainer}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {markdown.markdown}
      </ReactMarkdown>
    </div>
  );
};
